export default function Relatorio2() {
    return (
      <div className="p-8">
        <h1 className="text-2xl font-bold">Relatório 2</h1>
        <p>Conteúdo do relatório 2.</p>
      </div>
    );
  }
  